// @flow
import React, { Component } from 'react'
import _ from 'lodash'
import Button from '../controls/PrimaryButton'
import { groupHeaders } from '../controls/groupHeaders'
import styled, { type StyledComponent } from 'styled-components'
import Checkbox from '../controls/Checkbox'
import { translations } from '../../shared/localize'
import DraggableList from '../controls/DraggableList'
import { linkColor } from '../controls/colors'
import { Collapser, CollapserTriangle } from './CampaignTableRow'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  width: 100%;
`
const Columns = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 20px;
`
const CheckboxColumn: StyledComponent<Object, any, any> = styled.div`
  width: 50%;
`
const StyledDraggableList: typeof DraggableList = styled(DraggableList)`
  width: 50%;
  overflow: auto;
  height: 400px;
  padding-top: 10px;
`
const FieldGroupLabel = styled.div`
  font-size: 14px;
  color: gray;
`
const FieldRow = styled.div`
  margin-bottom: 5px;
  font-size: 16px;
`
const DraggableItem = styled.span`
  font-size: 14px;
  border: 1px solid ${linkColor};
  border-radius: 2px;
  cursor: move;
  padding: 2px 5px;
`

type Props = {|
  headers: Array<string>,
  allHeaders: Array<string>,
  selectedFields: Array<string>,
  onChange: Function,
  onApply: Function
|}

type State = {|
  collapsedFieldTypes: Array<string>
|}

const t = {
  apply: 'Применить'
}
const headerT = translations.table_headers
const headerGroupT = translations.statistics

const NON_DRAGGABLE_HEADERS = ['status_checkbox', 'campaign', 'status', 'advertisements']

export default class TableHeaders extends Component<Props, State> {
  listContainer: any

  constructor(props: Props) {
    super(props)

    this.state = {
      collapsedFieldTypes: []
    }
  }
  render() {
    const { onApply } = this.props
    return (
      <Wrapper className="t-TableHeadersModal">
        <Columns>
          {this.renderCheckboxes()}
          {this.renderList()}
        </Columns>
        <Button onClick={() => onApply()}>{t.apply}</Button>
      </Wrapper>
    )
  }

  renderCheckboxes() {
    const { allHeaders, selectedFields } = this.props
    const { collapsedFieldTypes } = this.state
    return (
      <CheckboxColumn>
        {_.map(groupHeaders(allHeaders), (fields, fieldType: string) => {
          return (
            <div key={fieldType}>
              <FieldRow>
                <Collapser onClick={() => this.fieldTypeCollapserClicked(fieldType)}>
                  <FieldGroupLabel>{headerGroupT[fieldType]}</FieldGroupLabel>
                  <CollapserTriangle isActive={!_.includes(collapsedFieldTypes, fieldType)} />
                </Collapser>
              </FieldRow>
              {!_.includes(collapsedFieldTypes, fieldType) &&
                _.map(fields, (field, index: number) => {
                  return (
                    <FieldRow key={`${field}_${index}`}>
                      <Checkbox
                        className={`t-TableHeadersCheckbox__${field}`}
                        checked={_.includes(selectedFields, field)}
                        liteDisableMode
                        onChange={(checked) => this.headersChanged(field, checked)}
                        label={headerT[field]}
                        compact
                        alignBaseline
                      />
                    </FieldRow>
                  )
                })}
            </div>
          )
        })}
      </CheckboxColumn>
    )
  }

  renderList() {
    const { headers, onChange } = this.props
    const firstHeaders = _.take(headers, NON_DRAGGABLE_HEADERS.length)
    const lastHeader = _.last(headers)
    const draggableHeaders = _.without(headers, ...firstHeaders, lastHeader)
    return (
      <StyledDraggableList
        items={draggableHeaders}
        renderItem={(header: string) => <DraggableItem>{headerT[header]}</DraggableItem>}
        padding={15}
        onChange={(headers) => onChange([...firstHeaders, ...headers, lastHeader])}
      />
    )
  }

  headersChanged(field: string, checked: boolean) {
    const { headers, onChange } = this.props
    let newHeaders = this.checkboxData(headers, field, checked)
    onChange(newHeaders)
  }

  checkboxData(headers: Array<string>, item: string, checked: boolean): Array<string> {
    if (checked) {
      headers.splice(headers.length - 1, 0, item)
      return _.uniq(headers)
    } else {
      return _.without(headers, item)
    }
  }

  fieldTypeCollapserClicked(fieldType: string) {
    const { collapsedFieldTypes } = this.state
    const isCollapsed = _.includes(collapsedFieldTypes, fieldType)
    const fieldTypes = isCollapsed
      ? _.without(collapsedFieldTypes, fieldType)
      : _.uniq(_.concat(collapsedFieldTypes, fieldType))
    this.setState({ collapsedFieldTypes: fieldTypes })
  }
}
